import {Component} from "@angular/core";
import {Notify} from "../../services/Notify";
import {Session} from "../../services/Session";
import {
  DistributionImport,
  IDistributionImportError,
  IDistributionImportStatus
} from "../../services/DistributionImport";

@Component({
  selector: 'distribution-import',
  templateUrl: 'distribution_import.html',
})
export class DistributionImportCmp {
  public newFileData: File;
  public newFileName: string;
  public uploading = false;
  public working = false;
  public uploadId: number;
  public st: IDistributionImportStatus;
  public errorsPage: IDistributionImportError[] = [];
  public page = 0;
  public perPage = 50;
  private pollTimer;

  constructor(private session: Session, private di: DistributionImport) {
    this.session.redirectIfNotAuth();
  }

  ngOnDestroy() {
    if (this.pollTimer) {
      clearTimeout(this.pollTimer);
    }
  }

  addFile(files) {
    if (!files || !files[0]) {
      return;
    }
    let f = files[0];
    if (!f.name || !f.name.toLowerCase().endsWith('.xlsx')) {
      let n = new Notify();
      n.error('Wrong format of file. Please choose xlsx. file.');
      return;
    }
    this.reset();
    this.newFileName = f.name;
    this.newFileData = f;
  }

  reset() {
    if (this.pollTimer) {
      clearTimeout(this.pollTimer);
      this.pollTimer = null;
    }
    this.newFileData = null;
    this.newFileName = null;
    this.uploading = false;
    this.working = false;
    this.uploadId = null;
    this.st = null;
    this.errorsPage = [];
    this.page = 0;
  }

  upload() {
    if (!this.newFileData || !this.newFileName || this.uploading) {
      return;
    }
    this.uploading = true;
    this.di.uploadFile(this.newFileName, this.newFileData).subscribe((r) => {
      this.uploading = false;
      if (r && r.id) {
        this.uploadId = r.id;
        this.refreshStatus();
      } else {
        let n = new Notify();
        n.error('Upload failed');
      }
    }, (err) => {
      this.uploading = false;
      let n = new Notify();
      if (err && err.error && typeof err.error === 'string') {
        n.error(err.error);
      } else {
        n.httpErr(err);
      }
    });
  }

  dryRun() {
    if (!this.uploadId || this.working) {
      return;
    }
    this.working = true;
    this.di.dryRun(this.uploadId).subscribe(() => {
      this.poll();
    }, (err) => {
      this.working = false;
      let n = new Notify();
      if (err && err.error && typeof err.error === 'string') {
        n.error(err.error);
      } else {
        n.httpErr(err);
      }
    });
  }

  runImport() {
    if (!this.uploadId || this.working || !this.st || !this.st.ready_for_import) {
      return;
    }
    this.working = true;
    this.di.execute(this.uploadId).subscribe(() => {
      this.poll();
    }, (err) => {
      this.working = false;
      let n = new Notify();
      if (err && err.error && typeof err.error === 'string') {
        n.error(err.error);
      } else {
        n.httpErr(err);
      }
    });
  }

  poll() {
    if (!this.uploadId) {
      return;
    }
    this.pollTimer = setTimeout(() => {
      this.di.getStatus(this.uploadId).subscribe((st) => {
        this.applyStatus(st);
        if (st && (st.status === 'validating' || st.status === 'importing')) {
          this.poll();
        } else {
          this.working = false;
          if (st && st.status === 'error' && st.error_message) {
            let n = new Notify();
            n.error(st.error_message);
          }
          if (st && st.status === 'imported') {
            let n = new Notify();
            n.success('Import finished');
          }
        }
      }, (err) => {
        this.working = false;
        let n = new Notify();
        n.httpErr(err);
      });
    }, 1000);
  }

  refreshStatus() {
    if (!this.uploadId) {
      return;
    }
    this.di.getStatus(this.uploadId).subscribe((st) => {
      this.applyStatus(st);
    }, (err) => {
      let n = new Notify();
      n.httpErr(err);
    });
  }

  applyStatus(st: IDistributionImportStatus) {
    this.st = st;
    this.renderErrorsPage();
  }

  renderErrorsPage() {
    if (!this.st || !this.st.errors) {
      this.errorsPage = [];
      return;
    }
    let maxPage = Math.max(0, Math.ceil(this.st.errors.length / this.perPage) - 1);
    if (this.page > maxPage) {
      this.page = maxPage;
    }
    this.errorsPage = this.st.errors.slice(this.page * this.perPage, (this.page + 1) * this.perPage);
  }

  prevPage() {
    if (this.page > 0) {
      this.page--;
      this.renderErrorsPage();
    }
  }

  nextPage() {
    if (this.st && this.st.errors && (this.page + 1) * this.perPage < this.st.errors.length) {
      this.page++;
      this.renderErrorsPage();
    }
  }

  reportUrl(): string {
    if (!this.uploadId) {
      return '';
    }
    return this.di.reportUrl(this.uploadId);
  }
}
